import React from 'react';
import { useFormContext } from 'react-hook-form';
import './style.scss';

export default function EventNote() {
  const { watch } = useFormContext() || {};
  const formImportantNotes = watch ? watch('importantNotes') : null;
  const formTermCond = watch ? watch('termCond') : null;

  const notesText = formImportantNotes || formTermCond || '';
  const noteLines = notesText ? notesText.split('\n').filter((line) => line.trim() !== '') : [];

  return (
    <div className="please-note-container">
      {noteLines.length > 0 && (
        <div className="please-note-section">
          <div className="event-note-title">PLEASE NOTE</div>
          <div className="please-note-list">
            {noteLines.map((note, index) => (
              <div key={index} className="note-item">
                <span className="bullet">•</span>
                <span className="note-text">{note}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="notes-to-host-section">
        <div className="event-note-title">NOTES TO THE HOST</div>
        <textarea
          name="notes-to-host"
          className="host-textarea"
          placeholder="Optional message to the host..."
          disabled
        />
      </div>
    </div>
  );
}
